import { render, staticRenderFns } from "./VistoriasDetalhes.vue?vue&type=template&id=117beee8&scoped=true"
import script from "./VistoriasDetalhes.vue?vue&type=script&lang=js"
export * from "./VistoriasDetalhes.vue?vue&type=script&lang=js"
import style0 from "./VistoriasDetalhes.vue?vue&type=style&index=0&id=117beee8&prod&scoped=true&lang=scss"
import style1 from "./VistoriasDetalhes.vue?vue&type=style&index=1&id=117beee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117beee8",
  null
  
)

export default component.exports